/** Shared Tailwind class strings for the Regularizacion landing */

export const REG_FONTS = {
  body: "'DM Sans', sans-serif",
  heading: "'Source Serif 4', serif",
};

export const card =
  'bg-white rounded-2xl shadow-[0_2px_12px_rgba(0,0,0,0.06)] overflow-hidden animate-fadeUp';

export const cardBody = 'px-7 py-6 max-sm:px-5';

export const flagBar = (
  <div className="flex h-[30px] rounded-t-2xl overflow-hidden">
    <div className="flex-1 bg-[#c60b1e]" />
    <div className="flex-[2] bg-[#ffc400]" />
    <div className="flex-1 bg-[#c60b1e]" />
  </div>
);

export const btnPrimary =
  'bg-[#2e7d32] hover:bg-[#1b5e20] text-white font-semibold py-3 px-8 rounded-xl transition-colors duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed';

export const btnSecondary =
  'border-2 border-[#e0e0e0] text-[#444] font-semibold py-3 px-8 rounded-xl hover:border-[#2e7d32] hover:text-[#2e7d32] transition-colors duration-200 cursor-pointer';

export const container = 'max-w-[720px] mx-auto px-4 pt-8 pb-16 max-sm:px-3';
